module.exports = __webpack_public_path__ + "static/img/no-receipts-found.014282ce.svg";